"use client";

import { m } from "framer-motion";
import { Play } from "lucide-react";

const socialPlatforms = [
  {
    name: "Instagram",
    href: "https://www.instagram.com/dmd_studio_gmbh/",
    icon: (
      <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
      </svg>
    ),
  },
  {
    name: "LinkedIn",
    href: "https://www.linkedin.com/company/dmd-studio-gmbh",
    icon: (
      <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    ),
  },
  {
    name: "TikTok",
    href: "https://www.tiktok.com/@dmd_studio_gmbh",
    icon: (
      <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
      </svg>
    ),
  },
  {
    name: "Facebook",
    href: "https://www.facebook.com/people/DMD-Studio-GmbH/61579523897431/",
    icon: (
      <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
      </svg>
    ),
  },
];

const videos = [
  { id: 1, thumbnail: "/images/social/video-1.jpg", title: "Behind the Scenes" },
  { id: 2, thumbnail: "/images/social/video-2.jpg", title: "Projekt-Einblick" },
  { id: 3, thumbnail: "/images/social/video-3.jpg", title: "Team & Kultur" },
  { id: 4, thumbnail: "/images/social/video-4.jpg", title: "Kundenprojekt" },
  { id: 5, thumbnail: "/images/social/video-5.jpg", title: "Agentur-Alltag" },
];

export function SocialMediaEinblicke() {
  return (
    <section className="py-16 lg:py-20" style={{ backgroundColor: "var(--bg)" }}>
      <div className="mx-auto max-w-7xl px-4 lg:px-8">
        {/* Section Header */}
        <m.div
          className="mx-auto max-w-3xl text-center"
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.3 }}
        >
          <p className="text-sm font-semibold text-brand-500">Social Media</p>
          <h2
            className="mt-3 text-2xl font-semibold tracking-tight sm:text-3xl"
            style={{ color: "var(--text)", letterSpacing: "-0.02em" }}
          >
            Einblicke unserer Social Media Präsenz
          </h2>
          <p className="mt-4 text-base leading-relaxed" style={{ color: "var(--text-tertiary)" }}>
            Folgen Sie uns auf unseren Social-Media-Kanälen und erleben Sie
            unseren Agentur-Alltag, Projekte und Tipps rund um digitales Marketing.
          </p>
        </m.div>

        {/* Social Platform Icons */}
        <m.div
          className="mt-8 flex items-center justify-center gap-4"
          initial={{ opacity: 0, y: 8 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.3, delay: 0.1 }}
        >
          {socialPlatforms.map((platform) => (
            <a
              key={platform.name}
              href={platform.href}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex h-12 w-12 items-center justify-center rounded-xl border transition-all duration-150 hover:border-brand-300 hover:shadow-md"
              style={{
                color: "var(--text-tertiary)",
                borderColor: "var(--border)",
                backgroundColor: "var(--card-bg)",
              }}
              aria-label={`DMD Studio auf ${platform.name}`}
            >
              <span className="transition-colors duration-150 group-hover:text-brand-500">
                {platform.icon}
              </span>
            </a>
          ))}
        </m.div>

        {/* Video Grid — portrait/vertical format */}
        <div className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-5">
          {videos.map((video, i) => (
            <m.div
              key={video.id}
              className="group relative aspect-[9/16] overflow-hidden rounded-2xl border"
              style={{
                borderColor: "var(--border)",
                backgroundColor: "var(--bg-tertiary)",
              }}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.3, delay: i * 0.06 }}
            >
              {/* Placeholder content — replace with actual video thumbnails */}
              <div className="flex h-full flex-col items-center justify-center p-4 text-center">
                <div
                  className="flex h-14 w-14 items-center justify-center rounded-full transition-transform duration-200 group-hover:scale-110"
                  style={{ backgroundColor: "var(--fi-brand-bg)" }}
                >
                  <Play className="h-6 w-6 translate-x-0.5" style={{ color: "var(--fi-brand-fg)" }} />
                </div>
                <p className="mt-3 text-sm font-medium" style={{ color: "var(--text-secondary)" }}>
                  {video.title}
                </p>
                <p className="mt-1 text-xs" style={{ color: "var(--text-quaternary)" }}>
                  Video {video.id}
                </p>
              </div>

              {/* Hover overlay */}
              <div className="absolute inset-0 bg-brand-500/5 opacity-0 transition-opacity duration-200 group-hover:opacity-100" />
            </m.div>
          ))}
        </div>
      </div>
    </section>
  );
}
